import { Link } from '@tanstack/react-router';
import { useTranslation } from '@/context/TranslationContext';
import { SEO, generateBreadcrumbSchema } from '@/components/shared/seo';
import styles from './legal.module.scss';

export function Legal() {
    const { t, language } = useTranslation();

    const breadcrumbSchema = generateBreadcrumbSchema([
        { name: language === 'de' ? 'Startseite' : 'Home', url: '/' },
        { name: t('IMPRINT.TITLE'), url: '/impressum' },
    ]);

    return (
        <main className={styles.legalPage}>
            <SEO
                title={t('IMPRINT.TITLE')}
                description={language === 'de' 
                    ? 'Impressum und rechtliche Informationen von KoriCode - Software-Entwicklung in München'
                    : 'Legal notice and information from KoriCode - Software development in Munich'}
                canonicalUrl="/impressum"
                language={language}
                noIndex={false}
                structuredData={breadcrumbSchema}
            />
            <div className={styles.container}>
                <Link to="/" className={styles.backLink}>
                    <i className='bx bx-arrow-back'></i> {t('NAV.HOME')}
                </Link>

                <h1>{t('IMPRINT.TITLE')}</h1>

                <section className={styles.section}>
                    <h2>{t('IMPRINT.SECTION2.TITLE')}</h2>
                    <p>
                        Berkin Koray B.<br />
                        80809 München
                    </p>
                
                    <p>
                        {t('IMPRINT.SECTION2.PHONE')}: +49 176 622 692 07<br />
                        {t('IMPRINT.SECTION2.EMAIL')}: kontakt@koricode.de
                    </p>
                </section>

                {/* <section className={styles.section}>
                    <h2>Umsatzsteuer-ID</h2>
                    <p>
                        Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br />
                        [Ihre USt-IdNr.]
                    </p>
                </section> */}

                <section className={styles.section}>
                    <h2>{t('IMPRINT.SECTION3.TITLE')}</h2>
                    <p>
                        {t('IMPRINT.SECTION3.TEXT1')}{' '}
                        <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer">
                            https://ec.europa.eu/consumers/odr/
                        </a>.<br />
                        {t('IMPRINT.SECTION3.TEXT2')}
                    </p>
                </section>

                <section className={styles.section}>
                    <h2>{t('IMPRINT.SECTION4.TITLE')}</h2>
                    <p>
                        {t('IMPRINT.SECTION4.TEXT')}
                    </p>
                </section>

                <section className={styles.section}>
                    <h2>{t('IMPRINT.SECTION6.TITLE')}</h2>
                    <h3>{t('IMPRINT.SECTION6.SUBTITLE1')}</h3>
                    <p>
                        {t('IMPRINT.SECTION6.TEXT1')}
                    </p>
                    <p>
                        {t('IMPRINT.SECTION6.TEXT2')}
                    </p>

                    <h3>{t('IMPRINT.SECTION6.SUBTITLE2')}</h3>
                    <p>
                        {t('IMPRINT.SECTION6.TEXT3')}
                    </p>
                    <p>
                        {t('IMPRINT.SECTION6.TEXT4')}
                    </p>

                    <h3>{t('IMPRINT.SECTION6.SUBTITLE3')}</h3>
                    <p>
                        {t('IMPRINT.SECTION6.TEXT5')}
                    </p>
                    <p>
                        {t('IMPRINT.SECTION6.TEXT6')}
                    </p>
                </section>
            </div>
        </main>
    );
}
